/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */

export default {
	name: "date-picker",
	props: ["format", "elementId", "date", "initialiseDate", "startDate", "endDate", "disabled"],
	emits: ["dateChange"],
	data() {
		return {
			selectElementId: "select",
			selectedValue: null
		};
	},
	methods: {
		onDateChange() {
            
		}
	},
	mounted: function () {
        
        
	},
	watch: {
		elementId: {
			handler: function () {
				var self = this;
				setTimeout(function () {
					$("#" + self.elementId).datepicker({
						format: {
							toDisplay: function (date, format, language) {
								var stringDate = moment(date).format(self.format);
								return stringDate;
							},
							toValue: function (date, format, language) {
								var newDate = new Date(date);
								//return new Date(newDate);
								return newDate;
							}
						}
					});

					$("#" + self.elementId).datepicker()
						.on("changeDate", function (e) {
							self.$emit("dateChange", e.target.value);
						});


					// if(self.initialiseDate){
					// 	// setTimeout(function (){
					// 	// 	if(self.date !== null && self.date !== undefined){
					// 	// 		$("#" + self.elementId).datepicker("setValue", moment(self.date).format(self.format)).datepicker('update');
					// 	// 		//$("#" + self.elementId).datepicker("setDate", self.date);
					// 	// 	}
					// 	// }, 500)
					// 	if(self.date !== null && self.date !== undefined){
					// 		var momentDate = moment(self.date).format(self.format);
					// 		console.log("momentDate", momentDate);
					// 		$("#" + self.elementId).datepicker("setDate", self.date);
					// 		//$("#" + self.elementId).datepicker("setDate", momentDate);
					// 		//$("#" + self.elementId).datepicker("setDate", self.date);
					// 	}
					// }
				}, 400);
                
			},
			immediate: true,
			deep: true
		},
		// initialiseDate:{
		// 	handler: function () {
		// 		if(this.initialiseDate){
		// 			// setTimeout(function (){
		// 			// 	if(self.date !== null && self.date !== undefined){
		// 			// 		$("#" + self.elementId).datepicker("setValue", moment(self.date).format(self.format)).datepicker('update');
		// 			// 		//$("#" + self.elementId).datepicker("setDate", self.date);
		// 			// 	}
		// 			// }, 500)
		// 			if(this.date !== null && this.date !== undefined){
		// 				$("#" + this.elementId).datepicker("setDate", moment(this.date).format(this.format));
		// 				//$("#" + self.elementId).datepicker("setDate", self.date);
		// 			}
		// 		}
		// 	},
		// 	immediate: true,
		// 	deep: true
		// },
		date:{
			handler: function () {
				console.log("date", this.date);
				var self = this;
				if(this.initialiseDate){
					// setTimeout(function (){
					// 	if(self.date !== null && self.date !== undefined){
					// 		$("#" + self.elementId).datepicker("setValue", moment(self.date).format(self.format)).datepicker('update');
					// 		//$("#" + self.elementId).datepicker("setDate", self.date);
					// 	}
					// }, 500)
					if(this.date !== null && this.date !== undefined){
						//$("#" + this.elementId).datepicker("setDate", moment(this.date, moment.ISO_8601).format(this.format));
						$("#" + self.elementId).datepicker("setDate", self.date);
					}
				}
				// //dates
				if(this.date === null || this.date === undefined){
					$("#" + self.elementId).datepicker("setDate", "");
				}
			},
			immediate: true,
			deep: true
		},
		endDate:{
			handler: function () {
				$("#" + this.elementId).datepicker("setEndDate", this.endDate);
			},
			immediate: true,
			deep: true
		}
	},
	unmounted: function () {
		console.log("unmounted");
		//$("#" + this.elementId).datepicker("destroy");
	}
};
